export const manifest = (() => {
function __memo(fn) {
	let value;
	return () => value ??= (value = fn());
}

return {
	appDir: "_app",
	appPath: "_app",
	assets: new Set([".DS_Store","blik.svg","chat-icon.svg","contact/address.svg","contact/business.svg","contact/office.svg","contact/people.svg","czynnosci-notarialne.jpg","discuss-icon.svg","documentsValidation-icon.svg","favicon.ico","hero.jpg","intro.jpg","logo-icon.png","logo.svg","mastercard.svg","oplaty-i-platnosci.jpg","robots.txt","rodo.jpg","signature-icon.svg","visa.svg"]),
	mimeTypes: {".svg":"image/svg+xml",".jpg":"image/jpeg",".png":"image/png",".txt":"text/plain"},
	_: {
		client: {start:"_app/immutable/entry/start.D0uVUhe5.js",app:"_app/immutable/entry/app.CHwzFRzG.js",imports:["_app/immutable/entry/start.D0uVUhe5.js","_app/immutable/chunks/DEKpzgLA.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/DcKRL2at.js","_app/immutable/entry/app.CHwzFRzG.js","_app/immutable/chunks/C1FmrZbK.js","_app/immutable/chunks/DiR_Syld.js","_app/immutable/chunks/zAv0u1wk.js","_app/immutable/chunks/B6Ikv-5C.js","_app/immutable/chunks/Cew_q46a.js","_app/immutable/chunks/DcKRL2at.js","_app/immutable/chunks/BkRTvK_t.js","_app/immutable/chunks/CFMktExA.js"],stylesheets:[],fonts:[],uses_env_dynamic_public:false},
		nodes: [
			__memo(() => import('./nodes/0.js')),
			__memo(() => import('./nodes/1.js')),
			__memo(() => import('./nodes/2.js')),
			__memo(() => import('./nodes/3.js')),
			__memo(() => import('./nodes/4.js')),
			__memo(() => import('./nodes/5.js')),
			__memo(() => import('./nodes/6.js')),
			__memo(() => import('./nodes/7.js')),
			__memo(() => import('./nodes/8.js')),
			__memo(() => import('./nodes/9.js')),
			__memo(() => import('./nodes/10.js')),
			__memo(() => import('./nodes/11.js')),
			__memo(() => import('./nodes/12.js')),
			__memo(() => import('./nodes/13.js'))
		],
		remotes: {
			
		},
		routes: [
			{
				id: "/",
				pattern: /^\/$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 3 },
				endpoint: null
			},
			{
				id: "/(admin)/admin",
				pattern: /^\/admin\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 4 },
				endpoint: __memo(() => import('./entries/endpoints/(admin)/admin/_server.ts.js'))
			},
			{
				id: "/(admin)/admin/home",
				pattern: /^\/admin\/home\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 5 },
				endpoint: null
			},
			{
				id: "/(admin)/admin/login",
				pattern: /^\/admin\/login\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 6 },
				endpoint: __memo(() => import('./entries/endpoints/(admin)/admin/login/_server.ts.js'))
			},
			{
				id: "/(admin)/admin/test",
				pattern: /^\/admin\/test\/?$/,
				params: [],
				page: { layouts: [0,2,], errors: [1,,], leaf: 7 },
				endpoint: null
			},
			{
				id: "/czynnosci-notarialne",
				pattern: /^\/czynnosci-notarialne\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 8 },
				endpoint: null
			},
			{
				id: "/dokumenty",
				pattern: /^\/dokumenty\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 9 },
				endpoint: null
			},
			{
				id: "/o-kancelarii",
				pattern: /^\/o-kancelarii\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 10 },
				endpoint: null
			},
			{
				id: "/oplaty-i-platnosci",
				pattern: /^\/oplaty-i-platnosci\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 11 },
				endpoint: null
			},
			{
				id: "/polityka-prywatnosci",
				pattern: /^\/polityka-prywatnosci\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 12 },
				endpoint: null
			},
			{
				id: "/rodo",
				pattern: /^\/rodo\/?$/,
				params: [],
				page: { layouts: [0,], errors: [1,], leaf: 13 },
				endpoint: null
			}
		],
		prerendered_routes: new Set([]),
		matchers: async () => {
			
			return {  };
		},
		server_assets: {}
	}
}
})();

export const prerendered = new Set([]);

export const base = "";